/**
 * Web-specific icon binding for food subcategories. Detection
 * (keywords, valid-set, confidence math) lives in `@splitfiesta/core`
 * and is shared with mobile; this file just maps the subcategory
 * keys core returns to lucide-react components for rendering.
 */
import {
  Beef,
  Cake,
  Candy,
  Carrot,
  Cherry,
  Coffee,
  Cookie,
  Croissant,
  Utensils as DefaultIcon,
  Egg,
  Fish,
  Hamburger,
  IceCream,
  Milk,
  Pizza,
  Popcorn,
  Rainbow,
  Salad,
  Sandwich,
  ShoppingCart,
  Soup,
  Tablets,
  Truck,
  Utensils,
} from 'lucide-react';

import {
  FOOD_CONFIG,
  FOOD_KEYWORDS,
  VALID_FOOD_SUBCATEGORIES,
  detectFoodSubcategory,
  detectFoodSubcategoryWithConfidence,
} from '@splitfiesta/core';

export {
  FOOD_CONFIG,
  FOOD_KEYWORDS,
  VALID_FOOD_SUBCATEGORIES,
  detectFoodSubcategory,
  detectFoodSubcategoryWithConfidence,
};

type FoodIcon = React.ComponentType<{ className?: string }>;

export const FOOD_SUBCATEGORY_ICONS: Record<string, FoodIcon> = {
  pizza: Pizza,
  hamburger: Hamburger,
  sandwich: Sandwich,
  soup: Soup,
  cafe: Coffee,
  bakery: Croissant,
  groceries: ShoppingCart,
  snacks: Popcorn,
  breakfast: Egg,
  dessert: Cake,
  fruit: Cherry,
  vegetables: Carrot,
  meat: Beef,
  seafood: Fish,
  dairy: Milk,
  steak: Beef,
  delivery: Truck,
  salad: Salad,
  sushi: Rainbow,
  restaurant: Utensils,
  icecream: IceCream,
  candy: Candy,
  pastry: Cookie,
  supplements: Tablets,
  default: DefaultIcon,
};

export function getFoodIcon(subcategory: string | null | undefined): FoodIcon {
  if (!subcategory || !(subcategory in FOOD_SUBCATEGORY_ICONS)) {
    return FOOD_SUBCATEGORY_ICONS.default;
  }
  return FOOD_SUBCATEGORY_ICONS[subcategory];
}
